import React from 'react';

const AddTeamMemberModal = ({
  isOpen,
  team,
  memberToAdd,
  setMemberToAdd,
  assignableUsers = [],
  onClose,
  handleAddTeamMember,
  isLoading,
}) => {
  if (!isOpen || !team) return null;

  return (
    <div className="fixed inset-0 bg-slate-900/50 backdrop-blur-xs flex items-center justify-center z-50 p-4">
      <div className="relative w-full max-w-md bg-white rounded-2xl shadow-2xl border border-slate-200 overflow-hidden text-slate-800 animate-fadeIn">
        <div className="p-4 px-5 border-b border-slate-100 bg-blue-600 text-white flex items-center justify-between">
          <h3 className="text-base font-bold">Add Team Member</h3>
          <button
            onClick={onClose}
            className="w-7 h-7 rounded-full bg-white/10 hover:bg-white/20 text-white flex items-center justify-center text-xs"
          >
            ✕
          </button>
        </div>

        <div className="p-5 space-y-4 text-xs">
          <p className="text-slate-600 font-medium">
            Add a member to: <span className="font-bold text-slate-900">{team.name}</span>
          </p>

          <div>
            <label className="block text-xs font-semibold text-slate-700 mb-1.5">Select User</label>
            <select
              required
              className="w-full bg-slate-50 border border-slate-200 focus:bg-white focus:border-blue-500 rounded-xl p-2.5 text-slate-800 focus:outline-none"
              value={memberToAdd}
              onChange={(e) => setMemberToAdd(e.target.value)}
            >
              <option value="">Select User</option>
              {assignableUsers
                .filter((u) => !team.members?.includes(u.id))
                .map((u) => (
                  <option key={u.id} value={u.id}>
                    {u.username} ({u.role})
                  </option>
                ))}
            </select>
          </div>

          <div className="flex justify-end gap-2.5 pt-2 border-t border-slate-100">
            <button
              onClick={onClose}
              className="px-4 py-2 text-xs font-bold text-slate-600 bg-slate-100 hover:bg-slate-200 rounded-xl transition-colors"
            >
              Cancel
            </button>
            <button
              onClick={handleAddTeamMember}
              disabled={isLoading || !memberToAdd}
              className="px-4 py-2 text-xs font-bold text-white bg-blue-600 hover:bg-blue-700 active:bg-blue-800 rounded-xl shadow-xs disabled:opacity-50 transition-all"
            >
              {isLoading ? 'Adding...' : 'Add Member'}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddTeamMemberModal;
